/**
 * It's a generated file, preferable to extend this in external file
 */
import {TransportTypeName} from 'common/enums';
import * as yup from 'common/yup';
import {TransportType} from 'types/TransportType';
import {AbstractTransport, transportTypeSchema} from '../Abstract/AbstractTransport';
import {transportTypeNameSchema} from '../TransportTypeName';
import {BiscomServer} from './BiscomServer';

export const BiscomTransport = AbstractTransport.shape({
   typeName: transportTypeNameSchema.default(TransportTypeName.BISCOM),
   transportType: transportTypeSchema.default(TransportType.enum.BISCOM),
   server: BiscomServer,
});
export type IBiscomTransport = yup.InferType<typeof BiscomTransport>;
